import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api, formatApiErrorDetail } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { UserPlus, ArrowLeft, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";

export default function Register() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const set = (k) => (e) => setForm((s) => ({ ...s, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/register", form);
      setDone(true);
      toast.success("Registrierung gesendet.");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F4F4F5] p-6">
        <div className="max-w-md w-full bg-white border border-zinc-200 rounded-sm p-8 text-center">
          <CheckCircle2 className="w-12 h-12 text-green-600 mx-auto mb-4" />
          <h2 className="font-display text-2xl uppercase mb-3">Antrag gesendet</h2>
          <p className="text-sm text-zinc-600 mb-6">
            Vielen Dank! Dein Account wartet jetzt auf Freigabe durch einen Admin. Sobald freigegeben kannst du dich einloggen.
          </p>
          <Link
            to="/login"
            className="inline-flex items-center justify-center bg-[#F97316] hover:bg-[#EA580C] text-white px-5 h-11 rounded-sm font-semibold tracking-wide"
          >
            Zum Login
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F4F4F5] p-6">
      <div className="max-w-md w-full" data-testid="register-page">
        <Link to="/login" className="inline-flex items-center text-sm text-zinc-600 hover:text-black mb-4">
          <ArrowLeft className="w-4 h-4 mr-1" /> Zurück zum Login
        </Link>
        <div className="bg-white border border-zinc-200 rounded-sm p-8">
          <div className="mono text-[11px] tracking-[0.25em] text-zinc-500 mb-2">
            02 · NEUER ACCOUNT
          </div>
          <h1 className="font-display text-3xl uppercase mb-2">Registrieren</h1>
          <p className="text-sm text-zinc-600 mb-6">
            Dein Account muss nach der Registrierung vom Admin freigegeben werden.
          </p>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label className="text-xs uppercase tracking-wider font-semibold">Name</Label>
              <Input
                value={form.name}
                onChange={set("name")}
                required
                data-testid="register-name-input"
                className="mt-1.5 rounded-sm border-zinc-400 h-11"
                placeholder="Vorname Nachname"
              />
            </div>
            <div>
              <Label className="text-xs uppercase tracking-wider font-semibold">E-Mail</Label>
              <Input
                type="email"
                value={form.email}
                onChange={set("email")}
                required
                data-testid="register-email-input"
                className="mt-1.5 rounded-sm border-zinc-400 h-11"
              />
            </div>
            <div>
              <Label className="text-xs uppercase tracking-wider font-semibold">Passwort</Label>
              <Input
                type="password"
                value={form.password}
                onChange={set("password")}
                required
                minLength={6}
                data-testid="register-password-input"
                className="mt-1.5 rounded-sm border-zinc-400 h-11"
                placeholder="mind. 6 Zeichen"
              />
            </div>
            <Button
              type="submit"
              disabled={loading}
              data-testid="register-submit-button"
              className="w-full bg-[#F97316] hover:bg-[#EA580C] text-white font-semibold rounded-sm h-11 tracking-wide"
            >
              <UserPlus className="w-4 h-4 mr-2" />
              {loading ? "SENDEN…" : "REGISTRIEREN"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
